module.exports = __webpack_public_path__ + "media/packs/images/flags/EG-662494cb6796d70cc87c894c3bc17bcd.svg";